<div class="whole-container">
    <div class="top-section-container">
        <div class="top-section generic-container">
            <div class="back-icon-container">
                <mat-icon class="icon" (click)="goBack()">arrow_back</mat-icon>
                <p class="category-heading">{{ category || productCategories.All }}</p>
            </div>
            <p class="heading-text">Discover amazing toy blocks and sets for endless creativity</p>
        </div>
    </div>

    <div class="bottom-section-container">
        <div class="bottom-section generic-container">
            <div class="filter-section" *ngIf="isOpenFilter">
                <div class="filter-section-heading">
                    <span class="filters">Filters</span>
                    <span class="clear" *ngIf="selectedSubCategories.length" (click)="clearFilterItems()"
                        >Clear All</span
                    >
                </div>

                <!-- filter section -->
                <div
                    class="sub-category-section"
                    *ngIf="availableSubCategories.length && !searchQuery && category !== productCategories.BuyBlocks"
                >
                    <div class="sub-category-heading">
                        <span>Sub Categories</span>
                    </div>

                    <!-- subCategory section -->
                    <div class="subCategories">
                        @for (subCategory of availableSubCategories; track subCategory; let i = $index) {
                        <div
                            class="subCategory"
                            [ngClass]="{ isActive: isActiveSubCategory(subCategory!) }"
                            (click)="selectSubCategory(subCategory!)"
                        >
                            <span>{{ subCategory }}</span>
                        </div>
                        }
                    </div>
                </div>

                <!-- Price Range -->
                <div class="price-range-section">
                    <div class="price-section-heading">
                        <p class="price-section-title">Price Range</p>
                    </div>

                    <div class="price-section">
                        <mat-form-field appearance="outline" class="box-outline dense-3">
                            <mat-label>Min Price</mat-label>
                            <input
                                matInput
                                type="number"
                                (blur)="onBlur($event, true)"
                                [(ngModel)]="minPrice"
                                (input)="onPriceChange($event)"
                                placeholder="Min Price"
                            />
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="box-outline dense-3">
                            <mat-label>Max Price</mat-label>
                            <input
                                matInput
                                type="number"
                                (blur)="onBlur($event, false)"
                                [(ngModel)]="maxPrice"
                                (input)="onPriceChange($event)"
                                placeholder="Max Price"
                            />
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <div class="product-section">
                <div class="product-section-top">
                    <div class="filter-btn-products-found-container">
                        <button mat-raised-button class="save-btn filter-btn" (click)="toggleFilterButton()">
                            <mat-icon>tune</mat-icon> Filter
                        </button>
                        <span class="products-found">{{ totalProducts }} products found</span>
                    </div>

                    <div class="price-sort">
                        <mat-form-field class="box-outline dense-3" appearance="outline">
                            <mat-label>SORT BY</mat-label>
                            <mat-select
                                [(value)]="selectedSort"
                                (selectionChange)="onPriceSortingChange($event)"
                                placeholder="SORT BY"
                            >
                                <mat-select-trigger>
                                    {{ sortLabel }}
                                </mat-select-trigger>
                                <mat-option value="hightolow">{{
                                    "productList.label.priceHighToLow" | translate
                                }}</mat-option>
                                <mat-option value="lowtohigh">{{
                                    "productList.label.priceLowToHigh" | translate
                                }}</mat-option>
                                <mat-option value="highestRated">Highest Rated</mat-option>
                            </mat-select>
                        </mat-form-field>

                        <div class="display-toggle">
                            <mat-icon class="grid-view-icon" (click)="clickgridView()" [class.active]="!isListView"
                                >grid_view</mat-icon
                            >
                            <mat-icon class="view-list-icon" (click)="clickViewList()" [class.active]="isListView"
                                >view_list</mat-icon
                            >
                        </div>
                    </div>
                </div>

                <div class="product-section-bottom-container">
                    <mat-spinner *ngIf="isLoading" class="loading-spinner" [diameter]="50"></mat-spinner>
                    <div class="filtering-data">
                        @for (item of selectedSubCategories; track $index) {
                        <p class="filter-item">
                            {{ item }}&nbsp;&nbsp;<mat-icon class="close-icon" (click)="removeFilterItem(item)"
                                >close</mat-icon
                            >
                        </p>
                        }
                    </div>
                    <div
                        class="product-section-bottom"
                        *ngIf="productList.length > 0; else noProducts"
                        [ngClass]="{ showList: isListView }"
                    >
                        @for (product of productList; track $index) {
                        <div class="animate-fade-in" [ngStyle]="{ 'animation-delay': $index * 0.05 + 's' }">
                            <app-product-card
                                [product]="product"
                                (isNavbarOpen)="setNavbarOpen($event)"
                            ></app-product-card>
                        </div>
                        }
                    </div>
                </div>

                <div *ngIf="this.totalProducts - this.productList.length > 0" class="btn-content">
                    <app-button
                        variant="hero"
                        *ngIf="!isLoading"
                        buttonClass="explore-btn shadow-btn"
                        (onClick)="onViewMoreClick()"
                    >
                        {{ "homePage.button.viewMoreBtn" | translate }}
                    </app-button>
                </div>

                <div class="right-navbar" *ngIf="isNavbarOpen">
                    <app-right-navbar (closeEvent)="onCloseNavbar()"></app-right-navbar>
                </div>

                <ng-template #noProducts>
                    <div class="no-results-message" *ngIf="!isLoading">
                        <div class="no-results-container">
                            <h1 class="no-product">
                                {{ "homePage.heading.productNotFound" | translate }}
                            </h1>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>
